module.exports = __webpack_public_path__ + "assets/media/day8.1454eacc.mp3";